import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { InlineCTA } from './InlineCTA';
export function PreCloseSection() {
  const benefits = ['Pasos claros para el momento real', 'Herramientas simples para usar en público o en casa', 'Más calma, menos culpa y menos improvisación'];
  return <section className="bg-white pt-8 pb-10 md:pt-12 md:pb-14 px-5 border-t border-gray-100" data-id="element-162">
      <div className="max-w-3xl mx-auto text-center" data-id="element-163">
        <h2 className="text-2xl md:text-4xl font-bold text-[#2D1F0E] mb-5" data-id="element-164">
          La próxima crisis no tiene que agarrarte igual
        </h2>

        <p className="text-[1.05rem] md:text-lg text-[#6B5D4F] leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-165">
          Este protocolo fue creado para madres que no necesitan más teoría.
          Necesitan una respuesta clara, rápida y práctica para esos momentos en
          los que todo se desborda.
        </p>

        <div className="flex flex-col items-center gap-4 mb-8" data-id="element-166">
          {benefits.map((benefit, idx) => <div key={idx} className="flex items-center gap-3 text-left w-full max-w-md" data-id="element-167">
              <CheckCircle2 className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-168" />
              <span className="text-[#2D1F0E] font-medium text-base md:text-lg" data-id="element-169">
                {benefit}
              </span>
            </div>)}
        </div>

        <InlineCTA text="Quiero saber qué hacer" data-id="element-170" />
      </div>
    </section>;
}